// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import tool from "../utils/tool";
Vue.use(tool);
// wap引入组件样式
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant)
// pc引入组件样式
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// import directive from "../utils/change.js";//数字变化
// Vue.directive("change", directive);// 注册名为 change 的指令

Vue.config.productionTip = false



import axios from 'axios'
//把axios对象挂到Vue实例上面，使用axios的时候直接全局调用this.$axios就可以了 
Vue.prototype.$axios = axios

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
// 复制
import Directives from '@/assets/wap/js/directives'
Vue.use(Directives)

// ES6
// import vshare from 'vshare';
//or require
// var vshare = require('vshare');
// Vue.use(vshare)
if (_isMobile()) {
	console.log('手机端')
	// wap端
		importMobileAssets();
} else {
	console.log('pc端')
	// PC端
		importPcAssets();
}
// 移动端文件
function importMobileAssets() {
	// 引入移动端资源
	import('@/assets/wap/css/iconfont.css');
	import('@/assets/wap/css/iconfontll.css');
	import('@/assets/wap/css/index.css');
	import('@/assets/wap/css/style.css');
}

// PC端文件
function importPcAssets() {
	// 引入PC端资源
	import("@/assets/pc/css/iconfont.css");
	import('@/assets/pc/css/iconfontll.css');
	import("@/assets/pc/css/style.css");
	import("@/assets/pc/css/index.css");

}

// 导入资源文件
import i18n from './lang'
// 检测是否为移动设备
function _isMobile() {
	// const width = window.innerWidth || document.documentElement.clientWidth;
	//  return width <= 768;
	let flag = navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	)
	return flag
}

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	i18n,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js